import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = { 
    showAnswer: Boolean 
  }

  connect() {
    if (!this.showAnswerValue) {
      sessionStorage.removeItem('cardStartTime')
      sessionStorage.setItem('cardStartTime', Date.now().toString())
      console.log("showing question")
    }else{
      console.log("showing answer")
    }
  }

  submit(event) {
    const startTime = parseInt(sessionStorage.getItem('cardStartTime'))
    const timeTakenSeconds = Math.round((Date.now() - startTime) / 1000)
    const form = event.currentTarget
    
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'time_taken'
    input.value = timeTakenSeconds
    form.appendChild(input)

    sessionStorage.removeItem('cardStartTime')
  }
}
